module.exports = __webpack_public_path__ + "c29e1eb82054b388396cd8188a70fb2f.png";